"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.RawCheckbox = void 0;
var react_1 = __importDefault(require("react"));
var react_onclickoutside_1 = __importDefault(require("react-onclickoutside"));
var Checkbox = function (_a) {
    var input = _a.input;
    return react_1["default"].createElement("label", null,
        react_1["default"].createElement("input", __assign({}, input, { type: "checkbox", value: "1", checked: input.value === '1', onChange: function (evt) { return input.onChange(evt.target.checked ? '1' : '0'); } })),
        "ja");
};
exports.RawCheckbox = Checkbox;
exports["default"] = (0, react_onclickoutside_1["default"])(Checkbox, {
    // @ts-ignore
    handleClickOutside: function (instance) { return function (evt) { return instance.props.input.onBlur(); }; }
});
